import React from 'react';
import { useSelector } from "react-redux";
import { openUrlInNewTab } from "../../shared/helpers";

import styles from './BannerWithLinkForCarousel.module.scss';

export default function BannerWithLinkForCarousel ({
   image,
   imageMobile,
   URI,
   title
}) {
	const { windowSize } = useSelector((state) => state.rootReducer);

	return (
		<div className={styles.wrapper} onClick={() => openUrlInNewTab(URI)}>
			<img className={styles.bannerImg} src={windowSize.isMobileView ? imageMobile : image} alt='' />
		</div>
	);
};